<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import api from '@/api';
import BoxFolderEditForm from '@/components-capability/admin/user-documents/box-folder-edit-form.vue';
import { useSnackbar } from '@/components/common/snackbar/use-snackbar';
import Header from '@/components/layouts/header.vue';
import { BoxFolder } from '@/types';

const initBoxFolders = ref<BoxFolder[]>([]);
const { createSnackbar } = useSnackbar();
const router = useRouter();
const isSubmitting = ref(false);

const submit = async (folders: BoxFolder[]) => {
  try {
    isSubmitting.value = true;
    await api.putBoxFolders(folders);
    await router.push({ name: 'boxIndex' });
  } catch {
    createSnackbar({
      message: 'BOXフォルダの更新に失敗しました',
      type: 'error',
    });
  } finally {
    isSubmitting.value = false;
  }
};

onMounted(async () => {
  try {
    initBoxFolders.value = await api.getBoxFolders(true);
  } catch {
    createSnackbar({
      message: 'BOXフォルダの取得に失敗しました',
      type: 'error',
    });
  }
});
</script>

<template>
  <div class="box-folder-create">
    <Header
      title="BOXフォルダ情報"
      header-width="min(912px, 100%)"
      is-one-line
    />
    <BoxFolderEditForm
      @submit="submit"
      :init-box-folders="initBoxFolders"
      :is-submitting="isSubmitting"
    />
  </div>
</template>

<style lang="scss" scoped>
.box-folder-create {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  padding: 0 !important;
}
</style>
